import { render, staticRenderFns } from "./VideoGridAlone.vue?vue&type=template&id=0362319b&scoped=true&"
import script from "./VideoGridAlone.vue?vue&type=script&lang=ts&"
export * from "./VideoGridAlone.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGridAlone.vue?vue&type=style&index=0&id=0362319b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0362319b",
  null
  
)

export default component.exports